import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock, MapPin } from "lucide-react";
import { EditableField } from "./EditableField";

/**
 * Rental Period Section for Rental Agreement
 */
export const RentalPeriodSection = ({ rentalPeriod, setRentalPeriod, isEditing }) => {
  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <Calendar className="w-4 h-4 text-primary" />
          RENTAL PERIOD
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Pickup */}
          <div className="space-y-3">
            <h4 className="text-xs font-semibold text-muted-foreground uppercase">
              Pickup
            </h4>
            <EditableField 
              label="Date" 
              value={rentalPeriod.pickupDate} 
              isEditing={isEditing} 
              type="date"
              onChange={(v) => setRentalPeriod({...rentalPeriod, pickupDate: v})} 
            />
            <EditableField 
              label="Time" 
              value={rentalPeriod.pickupTime} 
              isEditing={isEditing} 
              type="time"
              onChange={(v) => setRentalPeriod({...rentalPeriod, pickupTime: v})} 
              icon={<Clock className="w-3.5 h-3.5" />} 
            />
            <EditableField 
              label="Location" 
              value={rentalPeriod.pickupLocation} 
              isEditing={isEditing}
              onChange={(v) => setRentalPeriod({...rentalPeriod, pickupLocation: v})} 
              icon={<MapPin className="w-3.5 h-3.5" />} 
            />
          </div>
          
          {/* Return */}
          <div className="space-y-3">
            <h4 className="text-xs font-semibold text-muted-foreground uppercase">
              Return
            </h4>
            <EditableField 
              label="Date" 
              value={rentalPeriod.returnDate} 
              isEditing={isEditing} 
              type="date"
              onChange={(v) => setRentalPeriod({...rentalPeriod, returnDate: v})} 
            />
            <EditableField 
              label="Time" 
              value={rentalPeriod.returnTime} 
              isEditing={isEditing} 
              type="time"
              onChange={(v) => setRentalPeriod({...rentalPeriod, returnTime: v})} 
              icon={<Clock className="w-3.5 h-3.5" />} 
            />
            <EditableField 
              label="Location" 
              value={rentalPeriod.returnLocation} 
              isEditing={isEditing}
              onChange={(v) => setRentalPeriod({...rentalPeriod, returnLocation: v})} 
              icon={<MapPin className="w-3.5 h-3.5" />} 
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RentalPeriodSection;
